import React from 'react';

const ManageOrders = () => {
    return (
        <div>
            <h2>Manage Orders</h2>
        </div>
    );
};

export default ManageOrders;